/* 탭해서 고르는 보기(OPTIONS) — 응답 맨 끝줄의 `OPTIONS: 첫째 | 둘째` 를 읽어 버튼으로 만든다.
   ─────────────────────────────────────────────────────────────────────────
   Tutor.jsx 가 인라인으로 갖고 있던 규칙(:95, :131-133)을 순수 함수로 뽑았다.
   Study(문제풀이)에서도 같은 방식으로 쓰려면 한 군데에 있어야 한다.

   왜 구분자가 ' | '(양옆 공백)인가 — 수식의 세로막대와 헷갈리기 때문이다.
   절댓값 |x|, 조건부확률 P(A|B) 가 보기 두 개로 쪼개지면 안 된다.
   그래서 맨 | 는 구분자로 안 보고, 프롬프트에서도 \lvert…\rvert / \mid 를 쓰게 시킨다. */

const OPTION_SPLIT = /\s+\|\s+/;
const OPTIONS_LINE = /OPTIONS:\s*([^\n]+)/i;

/** 응답에서 OPTIONS 줄을 떼어낸 본문 */
function stripOptions(text){
  return String(text ?? "").replace(/\n*OPTIONS:[\s\S]*$/i, "").trimEnd();
}

/** 응답 → { body, options[] }. 보기가 없으면 options는 빈 배열. */
function parseOptions(text, { max = 4 } = {}){
  const s = String(text ?? "");
  const m = s.match(OPTIONS_LINE);
  const options = m
    ? m[1].split(OPTION_SPLIT)
        // 보기를 비워두면(`a |  | b`) 구분자가 한 번만 소비돼 다음 토큰이 '| b'로 남는다.
        // 앞에 새어나온 막대만 떼어낸다 — 뒤에 공백이 있을 때만이라 $|x|$ 같은 수식은 안 건드린다.
        .map(v => v.trim().replace(/^\|\s+/, "").trim())
        .filter(Boolean)
        .slice(0, max)
    : [];
  return { body: stripOptions(s), options };
}

/* 문제 풀다 막힌 학생에게 되묻는 상황용 규칙.
   Tutor 의 4단계 과외용 규칙과 달리, 여기선 '어디까지 아는지'를 캐는 데만 쓴다. */
const OPTIONS_RULE =
  "\n\n[보기 붙이는 법]\n" +
  "네가 던진 질문이 '이해했는지 / 어디까지 아는지'를 확인하는 것이면, 답변 맨 마지막 줄에 학습자가 탭해서 고를 보기를 붙여라:\n" +
  "OPTIONS: 첫 번째 보기 | 두 번째 보기\n" +
  "· 구분은 반드시 양옆에 공백을 둔 ' | '(스페이스+막대+스페이스)로만 한다. 보기 안 수식의 세로막대는 |…| 대신 \\lvert…\\rvert, P(A\\mid B) 처럼 LaTeX로 써라(맨 | 금지). 수식은 $…$로 감싸라.\n" +
  "· 보기는 2~3개, 각각 한 구절로 짧게. 학습자가 실제로 할 법한 말로.\n" +
  "· 예: \"…까지는 나왔어?\" → OPTIONS: 그건 알겠어 | 왜 그게 나와?\n" +
  "      \"…인 것도 알겠어?\" → OPTIONS: 어 이해했어 | 모르겠어\n" +
  "· 반대로 **학습자가 직접 써야 의미 있는 것**(풀이·유도·그래프 그리기)을 시켰을 땐 OPTIONS를 붙이지 마라 — 그땐 손으로 쓰게 둬라.";

export { parseOptions, stripOptions, OPTIONS_RULE, OPTION_SPLIT };
